import { Component, inject, input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { IDropdownOption, MatDropdown } from '../../../../../shared/components/mat-dropdown/mat-dropdown.component';
import { TableMappingDropdownStore } from './table-mapping-dropdown.store';

@Component({
  imports: [MatDropdown],
  providers: [TableMappingDropdownStore],
  selector: 'table-mapping-dropdown',
  styleUrl: './table-mapping-dropdown.component.scss',
  templateUrl: './table-mapping-dropdown.component.html',
})
export class TableMappingDropdownComponent implements OnInit {
  public readonly formControl = input.required<FormControl<IDropdownOption[]>>();
  public readonly isFormSubmitted = input.required<boolean>();

  public readonly store = inject(TableMappingDropdownStore);
  public readonly translate = inject(TranslateService);

  public readonly dropdownConfiguration = {
    enableSearchFilter: true,
    hasDelayedDefaultValue: true,
    isClientSide: true,
    repositionDropdownList: true,
    singleSelection: true,
    text: this.translate.instant('field.table'),
  };

  public ngOnInit(): void {
    this.store.loadMappings();
  }
}
